<section class="mt-4" >
  <div *ngIf="data" matBadge="{{data.length}}" matBadgeColor="warn" matBadgeOverlap="false" matBadgePosition="after"></div>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="h6 text-nowrap" i18n>Štátne skúšky</div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div *ngIf="data">
      <app-statna-skuska *ngFor="let s of data" [statnaSkuska]="s"></app-statna-skuska>
    </div>
    <hr/>
    <div class="d-flex flex-row align-items-center">
      <b><div><a class="me-5" (click)="openKontrolaPrerekvizit()" i18n i18n-title title="Kontrola prerekvizít">Kontrola prerekvizít</a></div></b>
      <b><div><a (click)="openPrihlasenieNaTermin()" i18n i18n-title title="Prihlásenie na termín">Prihlásenie na termín</a></div></b>
    </div>
  </mat-expansion-panel>
</section>
